import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/ApplyCreditLine.module.scss";
import DashboardClass from "@/utils/dashboard_class";
import CMS from "@/utils/cms";
import React, {useEffect, useState} from "react";
import {LocalLanguage} from "@/types_and_interfaces/types";
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import Button from "@/ui/Button.tsx";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";
import useCommon from "@/hooks/common";
import CommonClass from "@/utils/common";
import {useTranslation} from "react-i18next";
import PaymentMethodSwitcherMain from "@/ui/PaymentMethodsSwitcherMain.tsx";
import PaymentMethodsObjInterface from "@/types_and_interfaces/payment_methods_obj_interface.ts";
import useLoans from "@/hooks/loans.ts";
import {useAtom} from "jotai/index";
import {loan_sidebar_data} from "@/atoms/profile.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import LoginLoader from "@/ui/LoginLoader.tsx";

const ApplyCrLine = () => {
    const [paymentMethod, setPaymentMethod] = useState<keyof PaymentMethodsObjInterface | "">("")
    const [loading, setLoading] = useState<boolean>(false)
    const {t, } = useTranslation()
    const gen_data = CMS.general_info
    const dc = DashboardClass
    const [data] = useAtom(loan_sidebar_data)
    const applyData = data ? JSON.parse(data) : {}
    const [formErrors, setFormErrors] = useState({});
    const {urn} = useParams()
    const loans = useLoans()
    const cl_line_loans = loans.getLoansByType("Credit Line")?.filter((x) => x.r_status === "approved")
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")

    const navigate = useNavigate()
    
    const paymentMethodHandler = (x:keyof PaymentMethodsObjInterface) => {
        setPaymentMethod(x)
    }

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        let form = new FormData(e.currentTarget)
        let errors: any = {};
        
        if(applyData.amount && Number(applyData.amount)) {
            if(Number(applyData.amount) < 3000) {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "warning", t("min_mount_warn_cr_line"))
                return
            }
        }
        
        const bank = form.get("bank")
        const refund_bank = form.get("refund_bank")
        let refund_account:any = form.get("refund_account") || ""
        let iban_disb_shop = form.get("iban_disb_shop")
        let phone_disb_shop = form.get("phone_disb_shop")
        let identifier = form.get("identifier")
        const id = (Array.isArray(cl_line_loans) && cl_line_loans.length) ? cl_line_loans.find(item => item.urn === urn)?.id : ""
        let disb_shop:any = ""
        
        if(paymentMethod === "bank"){
            if (typeof refund_bank === "string" && !refund_bank.length) errors["refund_bank"] = t("bank_err")
            if ((typeof refund_account === "string" && !refund_account.length) || !CommonClass.check_iban(refund_account as string)) {
                errors["refund_account"] = t("refund_account_err")
                
            } else {
                if(!CommonClass.check_iban_by_bank(refund_account as string, identifier as string)) {
                    errors["refund_account"] = t("iban_not_of_bank_err").replace("{{bank}}", bank as string)
                }
            }
        }
        
        if(paymentMethod === "online_wallet") {
            if (typeof refund_bank === "string" && !refund_bank.length) errors["refund_bank"] = t("bank_err")
            if (typeof refund_account === "string" && !refund_account.length) errors["refund_account"] = t("refund_account_err1")
            
        }
        
        if(paymentMethod === "bank" || paymentMethod === "online_wallet") {
            if(typeof refund_account === "string" && refund_account.length) {
                
                if(refund_account.length >= 15 && /^[A-Za-z]/.test(refund_account)) {
                    
                    if(!CommonClass.check_iban(refund_account)) {
                        errors["refund_account"] = t("refund_account_err")
                    } else disb_shop = iban_disb_shop || ""
                    
                    if(CommonClass.check_iban(refund_account) && !CommonClass.check_iban_by_bank(refund_account as string, identifier as string)) {
                        errors["refund_account"] = t("iban_not_of_bank_err").replace("{{bank}}", bank as string)
                    }
                    
                } else {
                    
                    if (refund_account.startsWith("373")) {
                        refund_account = refund_account.substring(3);
                        
                    } else if (refund_account.startsWith("+373")) {
                        refund_account = refund_account.substring(4);
                        
                    }
                    if(refund_account.startsWith("0")) {
                        refund_account = refund_account.substring(1);
                    }
                    
                    refund_account = refund_account.replace(/\s+/g, '')
                    
                    if(refund_account.length !== 8) errors["refund_account"] = t("valid_nr_err")
                    
                    refund_account = CommonClass.formatNumber(refund_account)
                    
                    if(!CommonClass.phoneNumberValidate(refund_account)) errors["refund_account"] = t("valid_nr_err")
                    refund_account = "+373" + refund_account.replace(/\s+/g, '')
                    disb_shop = phone_disb_shop || ""
                }
            }
        }
        
        if(!id?.length) {
            errors["client_loan_id"] = t("error_message")
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("error_message"))
        }
        
        Object.keys(errors).map((k) => {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", errors[k])
        })
        
        const enabled = !Object.keys(errors).length
        
        setFormErrors(errors)
        
        function capitalizeFirstLetter(str:any) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        
        if(enabled) {
            let values:any = {
                client_loan_id: id,
                amount: applyData.amount,
                money_transfer_method:capitalizeFirstLetter(paymentMethod),

            }
            
            if(paymentMethod === "online_wallet" || paymentMethod === "bank") {
                values = {
                    ...values,
                    refund_bank: refund_bank,
                    refund_account: refund_account,
                    disb_shop
                }
            }
            
            if(debug === "true") {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "info", "delete debug query to continue")
                return false;
            }
            
            setLoading(true)
            let st = await loans.applyCrLineTransaction(values)
            setLoading(false)

            if(st === 200) {
                navigate(`${DashboardClass.dashboard_routes.SuccessApplyCrLine}/${urn}`)
            } else if(st === 409){
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "warning", t("record_already_exists"))
            } else {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("error_message"))
            }
            
        }
    }
    


    
    return gen_data && (
        <DashboardGenComponent

            responsive1

            header_type={"primary"}
            
            backUrl={dc.dashboard_routes.CreditLine}
            
            heading={
                <div className={st.heading}>
                    <h4>
                        {t("apply_for_credit_line")}
                    </h4>
                </div>
            }
            
            header_content={Object.keys(applyData).length ? (
                
                <div className={st.header_content}>
                    
                    <strong>
                        {t("amount")}
                    </strong>
                    
                    <strong className={st.amount}>
                        {CommonClass.formatMoneyAmount(Number(applyData.amount))  + " " + t("currency")}
                    </strong>
                
                </div>
            ) : null}
            
            column_center={
                <>
                    {/*{recieveType === "cash" && <RecieveCash/>}*/}
                    {/*{recieveType === "online_wallet" && <RecieveOnlineWallet online_wallets={online_wallets}/>}*/}
                    {/*{recieveType === "card" && <RecieveCreditCard/>}*/}
                    
                    <form className={st.form_column_center} onSubmit={onSubmit}>
                        
                        <PaymentMethodSwitcherMain
                            paymentMethod={paymentMethod as keyof PaymentMethodsObjInterface}
                            paymentMethodHandler={paymentMethodHandler}
                            formErrors={formErrors}
                        />
                        
                        <Button
                            type={"submit"}
                            // onClick={onSubmit}
                            className={st.submit_btn}
                            animated
                        >
                            <span>
                                {t("continue")}
                            </span>
                        </Button>
                        
                        
                        {loading && <LoginLoader />}
                    </form>
                    

                </>
            }
            
            column_right={
                <>
                    {paymentMethod === "cash" && <Locations/>}
                </>
            }
        />
    )
}




const Locations = () => {
    
    const offices = CMS.offices.offices
    // const {offices} = all_offices
    const navigate = useNavigate()
    const location = useLocation()
    const common_hook = useCommon()
    const {t, i18n} = useTranslation()

    const getLangAwareOffices = ():Array<any> => {
        let res:Array<any> = []
        
        if(Array.isArray(offices) && offices.length) {
            for(let off of offices) {
                res.push(CMS.langAwareFilter(off, (i18n.language as LocalLanguage)))
            }
        }
        
        return res
    }
    
    const langAwareOffices:Array<any> = getLangAwareOffices()
    
    useEffect(() => {
        if(location.pathname) {
            localStorage.setItem(CommonClass.local_storage_fields.prev_path, location.pathname)
        }
    }, [location]);

    return (
        <div className={st.locations}>
            
            <div className={st.h_container}>
                <strong className={st.off_h}>
                    {t("offices")}
                </strong>
                
                <button
                    onClick={() => {
                        navigate(DashboardClass.dashboard_routes.Locations)
                    }}
                >
                    
                    {t("detailed_page")}
                    
                    <ChevroneIcon />
                    
                </button>
            </div>
            
            
            <div className={st.offices}>
                {(Array.isArray(langAwareOffices) && langAwareOffices.length) ? langAwareOffices.map((x, i) => {
                    
                    const {
                        address,
                        central_office,
                        city_name,
                        free_days,
                        intermediate_office,
                        phone_numbers,
                        secondary_office,
                        text_schedule
                    } = x
                    
                    return (
                        <div className={st.office} key={`office_${i}`}>
                            <span className={st.office_st}>
                                {central_office && t("main_office")}
                                {secondary_office && t("secondary_office")}
                                {intermediate_office && t("intermediate_office")}
                            </span>
                            
                            <strong className={st.city_name}>
                                {city_name && city_name}
                            </strong>
                            
                            <span className={st.address}>
                                {address && address}
                            </span>
                            
                            <div className={st.text_schedule}>
                                <span>
                                    {text_schedule && text_schedule}
                                </span>
                                <span>
                                    {free_days && free_days}
                                </span>
                            </div>
                            
                            <div className={st.numbers}>
                                {(Array.isArray(phone_numbers) && phone_numbers.length) ? phone_numbers.map((n, j) => {
                                    return (
                                        <div onClick={() => {common_hook.handleTelTo(n.number)}} className={st.nr} key={`phone_number_${i}_${j}_${n. number}`}>
                                            {n.number}
                                        </div>
                                    )
                                }) : null}
                            </div>
                        </div>
                    )
                }) : null}
            </div>
        </div>
    )
}


export default ApplyCrLine